/**
 * PrivacyPolicySection Component
 * Long-form privacy policy content
 */

import { useTranslation } from "@/language"

export function PrivacyPolicySection() {
  const { t } = useTranslation("settings")

  return (
    <div className="flex flex-col gap-8">
      {/* Section Header */}
      <div>
        <h1 className="text-2xl font-bold text-charcoal uppercase section-heading">
          {t("privacyPolicy.title")}
        </h1>
        <p className="text-sm text-stone mt-1">{t("privacyPolicy.description")}</p>
      </div>

      {/* Policy Content */}
      <div className="flex flex-col gap-8">
        {/* Introduction */}
        <section className="flex flex-col gap-3">
          <h2 className="text-lg font-semibold text-charcoal">{t("privacyPolicy.introduction")}</h2>
          <p className="text-sm text-stone leading-relaxed">
            {t("privacyPolicy.introDescription")}
          </p>
          <p className="text-sm text-stone leading-relaxed">{t("privacyPolicy.introContent1")}</p>
          <p className="text-sm text-stone leading-relaxed">{t("privacyPolicy.introContent2")}</p>
          <p className="text-sm text-stone leading-relaxed">{t("privacyPolicy.introContent3")}</p>
        </section>

        {/* Information We Collect */}
        <section className="flex flex-col gap-3">
          <h2 className="text-lg font-semibold text-charcoal">
            {t("privacyPolicy.informationWeCollect")}
          </h2>
          <p className="text-sm text-stone leading-relaxed">
            {t("privacyPolicy.informationContent1")}
          </p>

          <p className="text-sm text-stone leading-relaxed">
            {t("privacyPolicy.informationContent2")}
          </p>
        </section>

        {/* How We Use Your Data */}
        <section className="flex flex-col gap-3">
          <h2 className="text-lg font-semibold text-charcoal">{t("privacyPolicy.howWeUseData")}</h2>
          <p className="text-sm text-stone leading-relaxed">{t("privacyPolicy.useDataContent")}</p>
        </section>
      </div>
    </div>
  )
}
